import { useMemo } from 'react';
import {
  FRAME_PRODUCT_CODE,
  MATTRESS_PRODUCT_CODE,
  MONTHLY_SUBSCRIPTION_CODE,
  RELAXATION_MASK_PRODUCT_CODE,
  YEARLY_SUBSCRIPTION_CODE,
} from '@/core/constants/product-ids';
import useBffCatalogProductsQuery from '@/core/queries/bff/catalog/use-bff-catalog-products-query';
import useBffCatalogSubscriptionsQuery from '@/core/queries/bff/catalog/use-bff-catalog-subscriptions-query';
import {
  findCatalogProductByCode,
  findCatalogSubscriptionByCatalogKey,
} from '@/core/utils/catalog/catalog-lookup';

/**
 * Resolves BFF catalog numeric string ids from stable product / subscription codes (same codes in every environment).
 */
export default function useResolvedCatalogProductIds(): {
  mattressId: string | undefined;
  frameId: string | undefined;
  maskId: string | undefined;
  yearlySubscriptionId: string | undefined;
  monthlySubscriptionId: string | undefined;
} {
  const { data: products } = useBffCatalogProductsQuery();
  const { data: subscriptions } = useBffCatalogSubscriptionsQuery();

  return useMemo(() => {
    const list = products?.data;
    const subs = subscriptions?.data;
    return {
      mattressId: findCatalogProductByCode(list, MATTRESS_PRODUCT_CODE)?.id,
      frameId: findCatalogProductByCode(list, FRAME_PRODUCT_CODE)?.id,
      maskId: findCatalogProductByCode(list, RELAXATION_MASK_PRODUCT_CODE)?.id,
      yearlySubscriptionId: findCatalogSubscriptionByCatalogKey(
        subs,
        YEARLY_SUBSCRIPTION_CODE,
      )?.id,
      monthlySubscriptionId: findCatalogSubscriptionByCatalogKey(
        subs,
        MONTHLY_SUBSCRIPTION_CODE,
      )?.id,
    };
  }, [products?.data, subscriptions?.data]);
}
